export default __webpack_public_path__ + "static/media/Group 1900.b9867bd9.svg";